import type { BusinessDetails, DesignedProps, DesignManifestEntry } from '@sarnia/shared';
import { EMAIL, PHONE } from './siteCheck';

export interface BusinessOnPage {
  patch: Partial<DesignedProps>;
  /** How many texts and buttons were changed. */
  changes: number;
}

/** tel: wants digits (and a leading +) only. */
export function telHref(phone: string): string {
  return `tel:${phone.replace(/[^\d+]/g, '')}`;
}

/**
 * Puts the owner's phone number and email address wherever the template still shows its samples: call and email
 * buttons, and phone numbers or emails inside text the owner has not edited. Text they have edited is left alone.
 */
export function businessOnPage(
  business: BusinessDetails,
  props: DesignedProps,
  entry: DesignManifestEntry,
  defaults: Record<string, string>
): BusinessOnPage {
  const links = { ...(props.links ?? {}) };
  const texts = { ...(props.texts ?? {}) };
  let changes = 0;

  entry.links.forEach((link, index) => {
    const key = String(index);
    if (links[key] !== undefined) return;
    if (business.phone && /^tel:/i.test(link.href)) {
      links[key] = telHref(business.phone);
      changes += 1;
    } else if (business.email && /^mailto:/i.test(link.href)) {
      links[key] = `mailto:${business.email}`;
      changes += 1;
    }
  });

  for (const [id, original] of Object.entries(defaults)) {
    if (texts[id] !== undefined) continue;
    let next = original;
    if (business.phone) next = next.replace(new RegExp(PHONE.source, 'g'), business.phone);
    if (business.email) next = next.replace(new RegExp(EMAIL.source, 'g'), business.email);
    if (next !== original) {
      texts[id] = next;
      changes += 1;
    }
  }

  return { patch: { links, texts }, changes };
}
